import { buildPromos } from '../../collectionPagePromo/scripts/index';

if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

const loadmoreButton = document.querySelector('.paginate-load-more');
if(!loadmoreButton) return;
const productGrid = document.querySelector('#product-grid');
if(!productGrid) return;
const nextUrl = window.location.href;
const pageCount = loadmoreButton.dataset.pageCount;
const COLLECTION_ID = loadmoreButton.dataset.collectionId;
let currentPage;

if (JSON.parse(sessionStorage.getItem('currentPage'))?.collectionId == COLLECTION_ID) {
    currentPage = JSON.parse(sessionStorage.getItem('currentPage')).page;
} else {
    currentPage = loadmoreButton.dataset.currentPage;    
}

if (document.querySelector('.paginate-load-more')) {
    loadmoreButton.addEventListener('click', async function() {
        console.log(pageCount);
        if (currentPage < pageCount) {
            currentPage++; 
            let source = await paginationFetch(currentPage);
            if (source) productGridBuild(productGrid, source);
        }
        if (currentPage >= pageCount) {
            this.classList.add('d-none');
        }
    })

    window.addEventListener('load', collectionPageLoad);
    
    window.onbeforeunload = function() {
        cache();
        window.removeEventListener('load', collectionPageLoad);
    };
}

function productGridBuild(productGrid, source) {
    productGrid.insertAdjacentHTML('beforeend', source);
    buildPromos();
}

function cache() {
    let data = JSON.parse(sessionStorage.getItem('currentPage')) || {}
    data.page = currentPage;
    data.scrollTop = window.scrollY;
    data.collectionId = COLLECTION_ID;
    sessionStorage.setItem('currentPage', JSON.stringify(data));
}

async function collectionPageLoad() {
    buildPromos();
    let storedPage = JSON.parse(sessionStorage.getItem('currentPage'));
    if (storedPage && storedPage.collectionId == COLLECTION_ID) {
        let scrollpos = storedPage.scrollTop;
        if (storedPage.page > 1) {
            for (let page = 2; page <= storedPage.page; page++) {
                let source = await paginationFetch(page);
                if (source) productGridBuild(productGrid, source);
            }
        }
        if (storedPage.page >= pageCount) {
            loadmoreButton.classList.add('d-none');
        }
        if (scrollpos) window.scrollTo(0, scrollpos);
    }
}

async function paginationFetch(page) {
    let url = new URL(nextUrl);
    url.searchParams.set('page', page);
    loadmoreButton.setAttribute('data-current-page', page);
    const response = await fetch(url.href);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.body.querySelector('#product-grid')?.innerHTML;
    return source;
}